import { useState, useEffect } from "react";
import {
  addNewService,
  editServices,
  deleteService,
} from "../../api/serviceApi";
import {
  getAllServicesGroup,
  createNewServiceGroup,
} from "../../api/servicesGroupApi";
import EditIcon from "../../assets/icons/edit-icon.png";
import DeleteIcon from "../../assets/icons/delete-icon.png";
import { useAuth } from "../../context/AuthContext";

const useService = () => {
  const [newService, setNewService] = useState({
    name: "",
    description: "",
    price: 0,
    isRepeatable: false,
    displayOrderNumber: 0,
  });
  const [services, setServices] = useState([]);
  const [selectedServiceGroup, setSelectedServiceGroup] = useState(null);
  const [displayServices, setDisplayServices] = useState([]);
  const [serviceGroupName, setServiceGroupName] = useState("");
  const [serviceGroupOrder, setServiceGroupOrder] = useState();
  const [showNewRow, setShowNewRow] = useState(false);
  const [editService, setEditService] = useState({});
  const [deleteItem, setDeleteItem] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [message, setMessage] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showNewModal, setShowNewModal] = useState(false);
  const [errors, setErrors] = useState({});
  const { user } = useAuth();
  const columns = [
    { header: "Service Name", accessor: "name" },
    { header: "description", accessor: "description" },
    { header: "Price", accessor: "price" },
    {
      header: "Is Repeatable",
      accessor: "isRepeatable",
      render: (row) => (row.isRepeatable ? "true" : "false"),
    },
    { header: "Display order Nr.", accessor: "displayOrderNumber" },
    {
      header: "Actions",
      render: (row, { onEdit, onDelete }) => (
        <>
          <button className="btn btn-edit " onClick={() => onEdit(row)}>
            <img src={EditIcon} />
          </button>
          <button className="btn btn-delete" onClick={() => onDelete(row)}>
            <img src={DeleteIcon} />
          </button>
        </>
      ),
    },
  ];
  useEffect(() => {
    setDisplayServices(selectedServiceGroup?.services || []);
    if (selectedServiceGroup?.services == 0) {
      setShowNewRow(true);
    } else {
      setShowNewRow(false);
    }
  }, [selectedServiceGroup]);

  useEffect(() => {
    fetchServices();
  }, []);
  useEffect(() => {
    if (showNewRow) {
      setNewService({
        name: "",
        description: "",
        price: 0,
        isRepeatable: false,
        displayOrderNumber: displayServices.length + 1,
      });
    }
  }, [showNewRow]);

  const fetchServices = async () => {
    const response = await getAllServicesGroup(user.barberShop);
    setServices(response);
    if (selectedServiceGroup?.name?.length > 0) {
      let index = response.findIndex(
        (x) => x.name == selectedServiceGroup.name,
      );
      setSelectedServiceGroup(response[index]);
      setServiceGroupName("");
    } else {
      setSelectedServiceGroup(response[0]);
    }
    setServiceGroupOrder(response.length + 1);
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setNewService((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const validateService = (service) => {
    const errors = {};
    if (!service.name || service.name.trim() === "") {
      errors.name = "Name is required";
    }

    if (!service.price || isNaN(service.price) || Number(service.price) <= 0) {
      errors.price = "Price must be a valid number greater than 0";
    }
    if (!service.selectedServiceGroup || !service.selectedServiceGroup.id) {
      errors.serviceGroup = "Service group is required";
    }

    if (
      service.displayOrderNumber !== undefined &&
      (isNaN(service.displayOrderNumber) || service.displayOrderNumber < 0)
    ) {
      errors.displayOrderNumber = "Display order must be a positive number";
    }

    return errors;
  };
  const onSave = async (service) => {
    const validationErrors = validateService(service);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);

      return; // stop execution
    }
    const newServieData = {
      ShopId: user.barberShop,
      Name: service.name,
      Description: service.description,
      Price: Number(service.price),
      ServiceGroupId: service.selectedServiceGroup.id,
      IsRepeatable: service.isRepeatable,
      displayOrderNumber: service.displayOrderNumber,
    };
    try {
      const response = await addNewService(
        newService,
        user.barberShop,
        newService.ServiceGroupId,
      );
      if (response.data.isSuccess) {
        setMessage({ text: response.data.value, type: "success" });
        setShowMessage(true);
        await fetchServices();
        setShowNewModal(false);
      } else {
        setMessage({
          text: response.data.errors.join("\n"),
          type: "danger",
        });
        setShowMessage(true);
        setShowNewModal(false);
      }
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
  };
  const onFormClick = async () => {
    try {
      const newServiceGroup = {
        name: serviceGroupName,
        orderNumber: 200,
      };
      const result = await createNewServiceGroup(
        newServiceGroup,
        user.barberShop,
      );
      await fetchServices();
      setShowNewModal(false);
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
  };
  const onEditClick = (service) => {
    setEditService(service);
    setShowEditModal(true);
    setShowNewModal(false);
    setErrors({});
  };
  const onAddClick = (service) => {
    setEditService(null);
    setShowEditModal(false);
    setShowNewModal(true);
    setErrors({});
  };
  const onCloseModalClick = (service) => {
    setEditService(null);
    setShowEditModal(false);
    setShowNewModal(false);
    setErrors({});
  };

  const onEditSave = async (service) => {
    try {
      var serviceGroup = selectedServiceGroup;
      const response = await editServices(service, user.barberShop);

      if (response.data.isSuccess) {
        setShowEditModal(false);
        setEditService(null);
        setMessage({ text: response.data.value, type: "success" });
        setShowMessage(true);
        await fetchServices();
      } else {
        setMessage({
          text: response.data.errors.join("\n"),
          type: "danger",
        });
        setShowMessage(true);
      }
    } catch (err) {
      console.error("Error updating service", err);
    }
  };
  const handleDeleteClick = (service) => {
    setDeleteItem(service);
    setShowDeleteModal(true);
  };
  const handleConfirmDelete = async () => {
    if (deleteItem) {
      const response = await deleteService(user.barberShop, deleteItem.id);
      if (response.isSuccess) {
        setMessage({ text: response.value, type: "success" });
        setShowMessage(true);
        setDeleteItem(null);
        setShowDeleteModal(false);
        fetchServices();
      } else {
        setMessage({ text: "Delete is failed", type: "danger" });
        setShowMessage(true);
        setShowDeleteModal(false);
        setDeleteItem(null);
      }
    }
  };
  const onCloseDeleteModal = () => setShowDeleteModal(false);
  return {
    newService,
    services,
    displayServices,
    selectedServiceGroup,
    handleChange,
    onSave,
    onCloseModalClick,
    setSelectedServiceGroup,
    serviceGroupName,
    setServiceGroupName,
    serviceGroupOrder,
    setServiceGroupOrder,
    onFormClick,
    showNewModal,
    setShowNewRow,
    editService,
    showEditModal,
    setShowEditModal,
    onAddClick,
    onEditClick,
    onEditSave,
    showMessage,
    message,
    setShowMessage,
    setDeleteItem,
    showDeleteModal,
    onCloseDeleteModal,
    handleDeleteClick,
    handleConfirmDelete,
    errors,
    columns,
  };
};
export default useService;
